<!-- @format -->

<div ngbDropdown #dropdown="ngbDropdown">
  <button ngbDropdownToggle type="button" [attr.disabled]="disabled || null" [ngClass]="buttonClasses"
    >{{ buttonText }}<sis-icon icon="chevron" iconClass="cw-90"></sis-icon
  ></button>

  <div ngbDropdownMenu role="menu" [class.dropdown-menu-right]="dropdownMenuRight">
    @for (option of options; track option) {
      @if (option.header) {
        <div class="dropdown-header">{{ option.label }}</div>
      }
      @if (!option.header) {
        <button
          type="button"
          ngbDropdownItem
          [title]="option.label"
          (click)="!option.disabled && onSelect(option.value)"
          [attr.disabled]="option.disabled || null"
          [attr.tabindex]="option.disabled ? -1 : 0"
          [attr.aria-disabled]="option.disabled"
          role="menuitem">
          <span class="option-label">{{ option.label }}</span>
          @if (option.info || option.disabled) {
            <span class="additional-info"
              >{{ option?.info }}
              @if (option.disabled) {
                <span class="d-block">{{ "SIS_COMPONENTS.SELECT.OPTION_DISABLED" | translate }}</span>
              }
            </span>
          }
        </button>
      }
    }
  </div>
</div>
